import { apiClientWithRefreshToken } from "@/api/apiClient";

export default async function DeleteClient(id: string): Promise<void> {
    await apiClientWithRefreshToken({
        url: `/clients/${id}`,
        method: "DELETE",
    });
}
